<template lang="html">
    <div class="plaque-moteur">
        <div class="plaque-moteur-frame">
            <h2>{{getTextArray('motor_nav')[0][getLangage]}}</h2>
            <el-row :gutter="24">
                <el-form-item class="rowNominalPower" :label="getText('motor_form_nominal_power')" prop="nominal_power" :show-message="showMessage('nominal_power')">
                    <el-input
                        type="number"
                        v-model="factoryEngine.nominal_power"
                        :min="1"
                        :max="9999"
                        required
                    ></el-input>
                </el-form-item>
                <el-col
                    :xs="24"
                    :md="12"
                >
                    <el-form-item :label="getText('motor_form_nominal_voltage')" prop="nominal_voltage" :show-message="showMessage('nominal_voltage')">
                        <el-tooltip class="formTooltip" placement="right" :content="getText('motor_form_nominal_voltage_tooltip_message')">
                            <el-input
                                type="number"
                                v-model="factoryEngine.nominal_voltage"
                                required
                            ></el-input>
                        </el-tooltip>
                    </el-form-item>
                </el-col>
                <el-col
                    :xs="24"
                    :md="12"
                >

                    <el-form-item :label="getText('motor_form_nominal_current')" prop="nominal_current" :show-message="showMessage('nominal_current')">
                        <el-tooltip class="formTooltip" effect="dark" placement="right" :content="getText('motor_form_nominal_current_tooltip_message')">
                            <el-input
                                type="number"
                                v-model="factoryEngine.nominal_current"
                                required
                            ></el-input>
                        </el-tooltip>
                    </el-form-item>
                </el-col>
                <el-col
                    :xs="24"
                    :md="12"
                >
                    <el-form-item :label="getText('motor_form_cos_phi')" prop="cos_phi" :show-message="showMessage('cos_phi')">
                        <el-tooltip class="formTooltip" effect="dark" placement="right" :content="getText('motor_form_cos_phi_tooltip_message')">
                            <el-input
                                type="number"
                                step="0.001"
                                v-model="factoryEngine.cos_phi"
                                required
                            ></el-input>
                        </el-tooltip>
                    </el-form-item>
                </el-col>
                <el-col
                    :xs="24"
                    :md="12"
                >
                    <el-form-item :label="getText('motor_form_nominal_speed')" prop="nominal_speed" :show-message="showMessage('nominal_speed')">
                        <el-tooltip class="formTooltip" effect="dark" placement="right" :content="getText('motor_form_nominal_speed_tooltip_message')">
                            <el-input
                                type="number"
                                v-model="factoryEngine.nominal_speed"
                                required
                            ></el-input>
                        </el-tooltip>
                    </el-form-item>
                </el-col>
                <el-col
                    :xs="24"
                    :md="12"
                >
                    <el-form-item prop="casing_type" class="formSelect" :show-message="showMessage('casing_type')" :label="getText('motor_form_name_structure_type')">
                        <el-select name="carcasse" id="carcasse" v-model="factoryEngine.casing_type" :placeholder="getText('motor_form_casing_placeholder')" required>
                            <el-option
                                v-for="opt in $store.state.casings"
                                :key="opt"
                                :label="getTranslation(opt)"
                                :value="opt"
                            >
                                {{getTranslation(opt)}}
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
import {mapGetters} from 'vuex';

export default {
    data() {
        return {
            msg: '',
            factory: {},
        };
    },
    props: {
        factoryEngine: {
            type: Object,
            required: true
        },
        rules: {
            type: Object,
            required: true
        },
    },
    computed: {
        ...mapGetters([
            'getText',
            'getTextArray',
            'getIE3SwitchMotor',
            'getLangage'
        ])
    },
    methods: {
        fixNominalPowerInt(value){

        },
        getNominalPowerChoices() {
            if (this.getIE3SwitchMotor != undefined) {
                let cost = Object.keys(this.getIE3SwitchMotor.costs);
                let efficiency = Object.keys(this.getIE3SwitchMotor.efficiencies);
                let nominalPowerChoices = cost.filter(value => -1 !== efficiency.indexOf(value));
                nominalPowerChoices.sort((a, b) => {
                    return parseFloat(a) - parseFloat(b);
                });
                return nominalPowerChoices;
            }
            return null;
        },
        showMessage(el) {
            if (this.factoryEngine[el] && this.factoryEngine[el].length)
                return true;
            return false;
        },
        getTranslation(opt) {
            return this.$store.state.trad[opt][this.getLangage];
        }
    }
};
</script>

<style lang="less">

@import '../../../less/variables';

input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outter-spin-button {
    -webkit-appearance: none;
}

.plaque-moteur {
    width: 80%;
    margin: auto;
    box-sizing: border-box;
    .el-row {
        position: static;
    }
    .el-col {
        max-height: 90.5px;
    }
    .el-form-item {
        width: 95%;
    }
    .rowNominalPower {
        flex-wrap: wrap;
        position: relative;
        .el-form-item__content {
            position: static;
            .el-row {
                position: static;
                .el-radio-group {
                    display: flex;
                    flex-direction: row;
                    flex-wrap: wrap;
                    align-items: center;
                    justify-content: space-around;
                    width: 100%;
                    margin: 20px 0;
                }
            }
        }
        .nominalPowerChoices {
            display: block;
            position: static;
            margin: 0 0 20px;
            input {
                // display: none;
                position: static;
            }
            span {
                padding: 10px 0 !important;
                position: static;
                display: block;
            }
        }
        .el-radio-button__orig-radio:checked+.el-radio-button__inner {
            background-color: @color-1;
            border-color: @color-1;
        }
        .el-radio-button:focus:not(.is-focus):not(:active) {
            box-shadow: none;
        }
        .el-radio-button__inner:hover {
            color: @color-1;
        }
    }
}
.plaque-moteur-frame {
    padding: 5px 15px 40px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    border: 5px solid #efefef !important;
    i {
        display: block;
        margin: 0 0 0 15px;
    }
    .noSwitchMotorInfo {
        color: @color-1;
        margin: 30px 5% 5% 0;
    }
}
// .moteur-header {
//     padding-bottom: 50px;
// }
.select-regulation, .select-application {
    margin-top: 40px;
    margin-bottom: 40px;
    .regulation-type, .application-type {
        display: block;
        width: 100%;
    }
    // .regulation-type-desc {
    //     display:block;
    //     width: 100%;
    //     font-size: 11px;
    //     line-height: 13px;
    //     margin-top: 20px;
    //     margin-bottom: 10px;
    //     .regulation-type-img {
    //         display:block;
    //         text-align: center;
    //         padding-bottom: 10px;
    //         img {
    //             max-width: 100%;
    //             max-height: 80px;
    //             margin: auto;
    //         }
    //     }
    // }
}
// .moteur-body {
//     display: block;
//     position: relative;
// }
h2 {
    width: 100%;
    text-align: center;
    font-weight: bold;
    text-transform: uppercase;
}

.main {
    width: 100%;
}

.el-tooltip__popper.formTooltip {
    background: @color-1 !important;
    color: black !important;
    .popper__arrow {
        border-right-color: @color-1 !important;
    }
    .popper__arrow::after {
        border-right-color: @color-1 !important;
    }
}

.formSelect {
    .el-select {
        margin: 0;
        width: 100%;
        input {
            padding: 0 20px;
        }
    }
}

.el-select .el-input.is-focus .el-input__inner {
    border-color: @color-1;
}

</style>



// WEBPACK FOOTER //
// src/components/partials/wizzard/PlaqueMoteurForm.vue